import React, { useCallback, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { blogsTableColumnsConfig } from "./blogsTableColumnDef";
import { Table } from "../../../component/table/Table";
import { useSelector } from "react-redux";
import { selectBlogFilter } from "../../../store/blog/blogFilterSlice";
import {
  selectAllBlogs,
  useGetBlogListQuery,
} from "../../../services/blog/blogApiSlice";
import { CategoryPageSkeleton } from "../../../component/skeleton/CategoryPageSkeleton";

export const BlogsTablePage = () => {
  const navigate = useNavigate();

  const { status, search } = useSelector(selectBlogFilter);

  const { isSuccess, isLoading, isFetching } = useGetBlogListQuery({
    search,
    status,
  });
  const blogList = useSelector(selectAllBlogs);

  const handleNavigateToBlogDetail = useCallback(
    (blogId) => {
      navigate(`/blogs/${blogId}`);
      console.log(blogId);
    },
    [navigate],
  );

  const columnDefs = useMemo(
    () => blogsTableColumnsConfig(handleNavigateToBlogDetail),
    [handleNavigateToBlogDetail],
  );
  return isSuccess ? (
    <Table
      data={blogList}
      columns={columnDefs}
      loading={isLoading || isFetching}
    />
  ) : (
    <CategoryPageSkeleton />
  );
};
